import { render, staticRenderFns } from "./test-template-edit.vue?vue&type=template&id=7430c635&scoped=true&"
import script from "./test-template-edit.vue?vue&type=script&lang=ts&"
export * from "./test-template-edit.vue?vue&type=script&lang=ts&"
import style0 from "./test-template-edit.vue?vue&type=style&index=0&id=7430c635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7430c635",
  null
  
)

export default component.exports